
export const environment = {
  production: false,
  rememberMeKey: '2_kfs_32sad_s',
  storageKey: '_01_A_zKoS',
  timerVerification: 'verificationTimerValue',
  base_url: 'https://stg-api.esqyre.com/onboarding/api/v1/',
  image_url: 'https://stg-api.esqyre.com/common/api/v1/Upload/uploadFile',
  common_url: 'https://stg-api.esqyre.com/common/api/v1/Content/',
  googleKey: 'AIzaSyAbsZUg1cv51-w4ejJh93F4w5DODotUWlk',
  operational_url: 'https://stg-api.esqyre.com/operational/api/v1/',
  track_url : 'https://track-stageweb.esqyre.com/',
  socket_url: 'https://stag-socket.esqyre.com',
  firebaseConfig: {
    apiKey: 'AIzaSyBFDv0rLCEm6M3GpGFz-YC21Il17kRJ1Ts',
    authDomain: 'esqyre-cars.firebaseapp.com',
    projectId: 'esqyre-cars',
    storageBucket: 'esqyre-cars.firebasestorage.app',
    messagingSenderId: '81689601348',
    appId: '1:81689601348:web:d6ba45e0a7264d58496311',
    measurementId: 'G-N8EDK7CLV9',
    vapidKey: 'BC1kZENinr1eTHAWcGJFYsBasPg8b4LTOW9NPynltJF2YT6ZI500NpjYlBTKkuvBzatQI_NF-tZnwD4f1wqoWJ0'
  },
  STRIPE_SECRET_KEY: 'sk_test_51PzXjhP0zHXo5NEz23hvKES40yyJ4YTkxqQHylXqTBr4tXtQcyjqzv9yyWxitH4iwAyyGwXmxWOhLkXhZOBPi0kT00PAZJAdbS',
  STRIPE_PUBLISH_KEY: 'pk_test_51RLpTSP6TPFxgOAM8YkFJd7xQWF4kOL76GhmtgqAL8SnmyLiz5GKIPBFb2piYGYYVpdKLt2Qnceot6N0t4AMSUV000wmJIMy3M',
  payment_url: 'https://stg-api.esqyre.com/operational/api/v1/',
  path: '/firebase-messaging-sw.js',
  scope: '/',
  signup_url: 'https://stageweb.esqyre.com/auth/corporate-login',


  currentAddress: 'currentAddress'

};